import React from "react";
import DocumentCard from "components/card/DocumentCard";
import { TrendingUp } from "lucide-react";

export const documents = [
    {
        title: "Promotion to Senior Developer",
        type: "Promotion",
        description: "Promotion letter with new role responsibilities and expectations.",
        date: "2024-03-01",
        effectiveDate: "March 1, 2024",
        size: "1.5 MB",
        status: "Completed",
        icon: <TrendingUp className="w-5 h-5 text-purple-600" />,
        docID: "DOC004",
        newRole: "Senior Developer",
        previousRole: "Mid-level Developer",

    },
];

const PromotionsDocument = () => {

    return (
        <div className="space-y-3">
            {documents.map((doc, index) => (
                <DocumentCard
                    key={index}
                    {...doc}
                    documentData={doc}
                    onDownload={() => console.log(`Download ${doc.title}`)}
                />
            ))}
        </div>
    );
};

export default PromotionsDocument;
